// Core packages
import { NgModule } from "@angular/core";

// Third party packages

// Custom packages - Modules
import { SharedModule } from "src/app/modules/shared.module";

// Custom packages - Components
import { DocumentArchiveDownloadDialogComponent } from "src/app/modules/properties/components/document-archive-download-dialog/document-archive-download-dialog.component";

/**
 * The «Scarica i documenti» dialog of the 3.0.0 archive, on its own.
 *
 * Two kinds of screens open it: the pages of the archive, through DocumentArchiveV3Module (lazy), and
 * the dialog of the mapping tab that lists the documents of an element (MAP-A1), which lives with the
 * mapping tab in PropertiesModule, i.e. in the initial bundle. A component belongs to one module only,
 * so the dialog sits here and both import it. This dialog and the service it calls are therefore in
 * the initial bundle; the other dialogs of the archive are not.
 *
 * @since 3.0.0
 */
@NgModule({
  imports: [SharedModule],
  declarations: [DocumentArchiveDownloadDialogComponent],
  entryComponents: [
    // Pre-Ivy requirement: the dialog is created at runtime by MatDialog
    DocumentArchiveDownloadDialogComponent,
  ],
})
export class DocumentArchiveDownloadDialogModule {}
